import { StopWatch } from "components/StopWatch"
import { Button, Image } from "react-bootstrap"
import useTimestampButton from "components/stopwatch/hooks/useTimestampButton"
import useTimestampActionCable from "components/stopwatch/hooks/useTimestampActionCable";
import { RedDot } from "components/RedDot";

const TimestampButton = (props) => {
    const {connected} = useTimestampActionCable();
    const {
        workspace_logo,
        isHidden,
        onClick,
        tracked_card,
    } = useTimestampButton({connected});

    if (isHidden) return null

    return(
        <Button
            variant={'extreme-white'}
            className={`py-4px px-2 fw-500 fs-12px border-brand-hover d-flex align-items-center mx-2 hover-underline text-truncate btn btn-extreme-white`}
            onClick={onClick}
            style={{maxWidth: 180}}
        >
            {
                workspace_logo && 
                <Image 
                    src={workspace_logo} 
                    className="rounded me-2"
                    style={{ height: '22px', width: '22px' }}
                />
            }

            <span className="text-truncate me-1">{ tracked_card?.name }</span>

            <RedDot size={8} pulsing={true} style={{marginLeft: 8}}/>
        </Button>
    )
}

export default TimestampButton